import {Findings as FindingsView} from '@github-ui/copilot-findings'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {Suspense} from 'react'
import {CollapsiblePanel} from './CollapsiblePanel'
import {ExpandableContent} from './ExpandableContent'
import styles from './Findings.module.css'
import {usePullRequestBasePath} from '../../stores/layout-selectors'

/** Findings section — suspends while deferred data loads */
export function Findings() {
  return (
    <CollapsiblePanel heading="Findings">
      <ErrorBoundary boundaryName="Findings" fallback={null}>
        <Suspense fallback={null}>
          <FindingsContent />
        </Suspense>
      </ErrorBoundary>
    </CollapsiblePanel>
  )
}

function FindingsContent() {
  const basePath = usePullRequestBasePath()

  return (
    <ExpandableContent sectionLabel="Findings">
      <div className={styles.list}>
        <FindingsView pullRequestBasePath={basePath} />
      </div>
    </ExpandableContent>
  )
}
